const api = `${process.env.PUBLIC_URL}/api`;

export const chatMemberApi = `${api}/chatMember.json`;
export const chatApi = `${api}/chats.json`;
export const contactApi = `${api}/contacts.json`;

export * from './Auth';
export * from './Products';
export * from './Users';
export * from './Common';